// extracted by mini-css-extract-plugin
module.exports = {"link":"menu-mobile-module__link___2O2Qz","sublink":"menu-mobile-module__sublink___19oe0"};